var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlideArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#11C2ED",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7199 14.863C31.048 15.1911 31.2323 15.6362 31.2323 16.1002C31.2323 16.5642 31.048 17.0093 30.7199 17.3375L22.0574 26L30.7199 34.6625C31.0387 34.9925 31.2151 35.4346 31.2111 35.8934C31.2071 36.3523 31.0231 36.7912 30.6986 37.1156C30.3742 37.4401 29.9352 37.6242 29.4764 37.6281C29.0175 37.6321 28.5755 37.4557 28.2454 37.137L18.3457 27.2372C18.0176 26.909 17.8333 26.464 17.8333 26C17.8333 25.5359 18.0176 25.0909 18.3457 24.7627L28.2454 14.863C28.5736 14.5349 29.0187 14.3506 29.4827 14.3506C29.9467 14.3506 30.3918 14.5349 30.7199 14.863Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideArrowLeft);
export default __webpack_public_path__ + "static/media/slide-arrow-left.d17a70a68e47b48cc30280effe82326e.svg";
export { ForwardRef as ReactComponent };